import { useEffect, useRef } from "react";
import { gantt } from "dhtmlx-gantt";
import React from "react";
import "./gantt.css";
import { showMessage } from "../../functions/popUpMessage";
import { _ } from "../../functions/translator";
import { connect } from "react-redux";
import { popUpMessageChange, 
  popUpMenuChange} from '../../actions/index.js';
import { bindActionCreators } from "redux";
import { getCardsGroupsData } from "../../functions/getData.js";

function GanttView(props) { 
    let container = useRef();
    
    useEffect(() => { 
      gantt.plugins({
        quick_info: true
      });
      gantt.config.date_format = "%Y-%m-%d";
      gantt.config.show_progress = false;
      gantt.config.reorder_grid_columns = true;
      gantt.i18n.setLocale("es");
      gantt.config.link = "start_to_start"
      gantt.templates.link_class = function (link) {
        var types = gantt.config.links;
        switch (link.type) {
          case types.finish_to_start:
            return "finish_to_start";
          case types.start_to_start:
            return "start_to_start";
          case types.finish_to_finish:
            return "finish_to_finish";
        }
      };
      gantt.config.columns = [
        {name: "text", label: "Protocolo", tree: true, min_width: 180, width: 200, resize:true},
        {name: "start_date", label:"Inicio", align: "center", width: 100, resize:true},
        {name: "end_date", label:"Fin", align: "center", width: 100, template: function(task){
            return gantt.templates.date_grid(task.end_date, task);
          }, resize:true},
      ];

      gantt.config.scale_height = 30*2;
      gantt.config.min_column_width = 50;
      gantt.config.scales = [
        { unit:"month", step:1, date:"%M, %Y"	},
        { unit:"day", step:1, date:"%d %M"	}
      ];

      gantt.config.layout = {
        css: "gantt_container",
        cols: [
          {
            width:400,
            min_width: 300,
            rows:[
              {view: "grid", scrollX: "gridScroll", scrollable: true, scrollY: "scrollVer"},
              {view: "scrollbar", id: "gridScroll", group:"horizontal"}
            ]
          },
          {resizer: true, width: 1},
          {
            rows:[
              {view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer"},
              {view: "scrollbar", id: "scrollHor", group:"horizontal"}
            ]
          },
          {view: "scrollbar", id: "scrollVer"}
        ]
      };
      gantt.attachEvent("onAfterTaskUpdate", async function(id, task) {
        // console.log("Tarea actualizada:", id, task);
        //let lastStartDate = props.projectData.cards_groups[id].attributes.start_date
        let cardsGroupData = await getCardsGroupsData([id])
        // console.log("cardsGroupData",cardsGroupData)
        let lastStartDate = Object.values(cardsGroupData)[0].attributes.start_date
        if (lastStartDate) {
          lastStartDate = lastStartDate.slice(0,10);
        }
        let lastFinishDate = Object.values(cardsGroupData)[0].attributes.finish_date
        //let lastFinishDate = props.projectData.cards_groups[id].attributes.finish_date
        if (lastFinishDate) {
          lastFinishDate = lastFinishDate.slice(0,10);
        }
        let newStartDate = new Date(task.start_date).toISOString().split('T')[0]
        let newFinishDate = new Date(task.end_date).toISOString().split('T')[0]
        // console.log("lastStartDate",lastStartDate)
        // console.log("lastFinishDate",lastFinishDate)
        // console.log("newStartDate",newStartDate)
        // console.log("newFinishDate",newFinishDate)
        // console.log("lastStartDate !== newStartDate",lastStartDate !== newStartDate)
        // console.log("lastFinishDate !== newFinishDate",lastFinishDate !== newFinishDate)


        if (lastStartDate !== newStartDate || lastFinishDate !== newFinishDate) {
          const message = '¿' + _(`Seguro que deseas cambiar la fecha de este protocolo`) + '?';
          const messageConfig = {
              removeDateChangeConfirmationCloseButton: true,
              dateChangeConfirmation: true,
              cardsGroupId: id,
              task: task,
              onCancel: () => {
                //console.log("gantt.getTask(id)",gantt.getTask(id))
                // lastStartDate = props.projectData.cards_groups[id].attributes.start_date
                // lastFinishDate = props.projectData.cards_groups[id].attributes.finish_date
                const task = gantt.getTask(id);
                //console.log("lastStartDate",lastStartDate)
                //console.log("lastFinishDate",lastFinishDate)
                if (lastStartDate && lastFinishDate) {
                  lastStartDate = lastStartDate.slice(0,10)
                  lastFinishDate = lastFinishDate.slice(0,10)
                  //console.log("old task",task)
                  task.start_date = new Date(lastStartDate + 'T00:00:00')
                  task.end_date = new Date(lastFinishDate + 'T00:00:00')
                  //console.log("new task",task)
                  gantt.updateTask(id)
                  gantt.refreshTask(id)
                } else {
                  task.start_date = new Date(props.projectData.days[props.projectData.days.length - 2].id + 'T00:00:00')
                  task.end_date = new Date(props.projectData.days[props.projectData.days.length - 1].id + 'T00:00:00')
                  //console.log("new task",task)
                  gantt.updateTask(id)
                  gantt.refreshTask(id)
                }
              },
              onConfirm :() => {
                const task = gantt.getTask(id);
                task.color = '#537cfa'
                gantt.updateTask(id)
                gantt.refreshTask(id)
              }
          };
          showMessage(props, message, messageConfig);
          //this.props.popUpMenuChange({ show: false })
        }
      });
      //console.log("container.current",container.current)
      //console.log("props.tasks",props.tasks)
      gantt.init(container.current);
      gantt.parse(props.tasks); 
      return () => { 
        gantt.clearAll(); 
        //container.current.innerHTML = ""; 
      }; 
    }, []); 
   
    return <div ref={container} className="gantt-dates-container"></div>; 
  }

  function mapStateToProps( state ){
    return {
        projectData : state.projectData,
    }
}

  function matchDispatchToProps( dispatch ){
      return bindActionCreators({ 
          popUpMessageChange : popUpMessageChange,
          popUpMenuChange : popUpMenuChange,
      }, dispatch)
  }

  export default connect(mapStateToProps, matchDispatchToProps)(GanttView)
